import React, { Component } from "react";
import { Card } from "@vitalsource/vstui";
import Clickable from "../Clickable";
import "../../../styles/AddProductWizard.css";

interface ProductTypeCardState {
  hasHover: boolean;
}

export interface ProductTypeCardProps {
  onSelected: () => void;
  icon: string;
  hoverIcon: string;
  title: string;
  description: string | JSX.Element;
}

export default class ProductTypeCard extends Component<ProductTypeCardProps, ProductTypeCardState> {

  constructor(props: ProductTypeCardProps) {
    super(props);

    this.state = {
      hasHover: false
    };

    this.hoverChange = this.hoverChange.bind(this);
  }

  hoverChange(hasHover: boolean) {
    this.setState({
      hasHover: hasHover
    })
  }

  render() {
    return (
        <Card className={"product-select__card"} interactive raised>
          <Clickable onHoverChange={this.hoverChange} onFocusChange={this.hoverChange} onClick={this.props.onSelected}>
            <button className={"product-select__button"}>
              <img src={this.state.hasHover ? this.props.hoverIcon : this.props.icon} />
              <h2 className={"product-select__title"}>{this.props.title}</h2>
              <p className={"product-select__desc"}>{this.props.description}</p>
            </button>
          </Clickable>
        </Card>
    )
  }
}
